
import angular from 'angular';
import { AncillariesService } from '../../../components/ib-web-ancillaries/ib-web-ancillaries-service';
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';
import { CommonsSessionStorageService } from 'ib-web-commons/dist/utils';

const controllerInfo = {
    module: 'ib-globick-transfers-module',
    inject: ['$scope', '$uibModalInstance', '$rootScope', '$window', '$timeout', '$document', '$compile', '$sce', 'localStorageService', 'CommonsGenericProxy', 'CommonsNewHttpUtilsErrorService', '$q', 'AncillariesConstants', 'ibGlobickTransfersService', 'CommonsUtilService', 'AncillariesService', 'CommonsSessionStorageService', 'DatalayerUtilsService', 'DatalayerConstants'],
    required: []
};
export class ibGlobickTransfersModalCtrl implements ng.IController {

    private tokenWidget;
    private flowApp = this.localStorageService.get('flowApp');

    constructor (
        private $scope: angular.IScope,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private $rootScope: CommonsRootScope,
        private $window: angular.IWindowService,
        private $timeout: angular.ITimeoutService,
        private $document: ng.IDocumentService,
        private $compile: angular.ICompileService,
        private $sce: any,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private CommonsGenericProxy: CommonsGenericProxy,
        private CommonsNewHttpUtilsErrorService: CommonsNewHttpUtilsErrorService,
        private $q: ng.IQService,
        private AncillariesConstants: AncillariesConstant,
        private ibGlobickTransfersService: any,
        private CommonsUtilService,
        private AncillariesService: AncillariesService,
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private DatalayerUtilsService: DatalayerUtilsService,
        private DatalayerConstants: DatalayerConstantsType
    ) {
        this.$scope.$on('closeTransferModal', this.close);
        this.$scope.$on('completeTransferFlow', this.completeTransferFlow);
    }

    /**
     * Initialize modal controller
     */
    $onInit (): void {
        if (this.flowApp === null) {
            this.flowApp = this.$rootScope.flowName;
        }
        this.loadWidgetsScripts();
        this.$timeout(() => {
            this.initTransferWidget();
        });
    }

    getEnvUrlToGetWidgetCode (): string {
        const env = '';
        const envCopy: any = {};
        (<any>Object).assign(envCopy, (<any>window).env);
        return envCopy.urlEnvironment;

    }

    loadWidgetsScripts (): void {

        const widgetVersion = '2.3.8';
        const baseUrl = this.getEnvUrlToGetWidgetCode();
        const urlTransfers = baseUrl + 'iberia-web-content/build-recoglobick-transfers/' + widgetVersion;

        const scriptTransferVendor = '<script type="text/javascript" src="' + this.$sce.trustAsResourceUrl(urlTransfers + '/static/js/2.vendor.chunk.js') + '"</script>';
        const scriptTransferMain = '<script type="text/javascript" src="' + this.$sce.trustAsResourceUrl(urlTransfers + '/static/js/main.chunk.js') + '"</script>';
        const scriptTransferRunTime = '<script type="text/javascript" src="' + this.$sce.trustAsResourceUrl(urlTransfers + '/static/js/runtime-main.js') + '"</script>';
        const cssTransfersMain = '<link rel="stylesheet" href="' + this.$sce.trustAsResourceUrl(urlTransfers + '/static/css/main.chunk.css') + '">';
        angular.element(this.$document).find('body').prepend(this.$compile(scriptTransferVendor)(this.$scope));
        angular.element(this.$document).find('body').prepend(this.$compile(scriptTransferMain)(this.$scope));
        angular.element(this.$document).find('body').prepend(this.$compile(scriptTransferRunTime)(this.$scope));

        angular.element(this.$document).find('body').prepend(this.$compile(cssTransfersMain)(this.$scope));
    }

    postOrderCallback = (evt) => {
        const dateGoingTrip = evt[0].goingTrip.startDate;
        const dateFormatGoingTrip = new Date(dateGoingTrip);
        const dateFormattedGoingTrip = String(dateFormatGoingTrip.getDate()).padStart(2, '0') + '/' + String(dateFormatGoingTrip.getMonth()+1).padStart(2, '0') + '/' + dateFormatGoingTrip.getFullYear();
        const dateFormattedServiceGoingTrip = dateFormatGoingTrip.getFullYear() + '-' + String(dateFormatGoingTrip.getMonth()+1).padStart(2, '0') + '-' + String(dateFormatGoingTrip.getDate()).padStart(2, '0') + 'T' + String(dateFormatGoingTrip.getHours()).padStart(2, '0') + ':' + String(dateFormatGoingTrip.getMinutes()).padStart(2, '0');

        let dateReturnTrip, dateFormatReturnTrip, dateFormattedReturnTrip, dateFormattedServiceReturnTrip;
        if (evt[0].returnTrip !== null) {
            dateReturnTrip = evt[0].returnTrip.startDate;
            dateFormatReturnTrip = new Date(dateReturnTrip);
            dateFormattedReturnTrip = String(dateFormatReturnTrip.getDate()).padStart(2, '0') + '/' + String(dateFormatReturnTrip.getMonth()+1).padStart(2, '0') + '/' + dateFormatReturnTrip.getFullYear();
            dateFormattedServiceReturnTrip = dateFormatReturnTrip.getFullYear() + '-' + String(dateFormatReturnTrip.getMonth()+1).padStart(2, '0') + '-' + String(dateFormatReturnTrip.getDate()).padStart(2, '0') + 'T' + String(dateFormatReturnTrip.getHours()).padStart(2, '0') + ':' + String(dateFormatReturnTrip.getMinutes()).padStart(2, '0');
        }

        const transferCar = evt[0].goingTrip.name;
        const priceGoing = evt[0].goingTrip.price;
        const priceReturn = evt[0].returnTrip ? evt[0].returnTrip.price : evt[0].goingTrip.price;
        const hash = this.localStorageService.get('clientBookingIdTransfer');
        const paymentOrderIdGoing = evt[0].goingTrip.paymentOrderId;
        const paymentOrderReferenceGoing = evt[0].goingTrip.paymentOrderReference;
        const paymentOrderIdReturn = evt[0].returnTrip ? evt[0].returnTrip.paymentOrderId : '';
        const paymentOrderReferenceReturn = evt[0].returnTrip ? evt[0].returnTrip.paymentOrderReference : '';

        if (evt[0].returnTrip) {
            this.AncillariesService.updateGlobickTransfersReturn(dateFormattedServiceGoingTrip, dateFormattedServiceReturnTrip, transferCar, priceGoing, priceReturn, hash, paymentOrderIdGoing, paymentOrderReferenceGoing, paymentOrderIdReturn, paymentOrderReferenceReturn).then(() => {
                this.AncillariesService.addGlobickTransfersToBasketReturn(this.AncillariesConstants.QUADRIGAM.ANCILLARIES_BKI.toLowerCase(), dateFormattedGoingTrip, dateFormattedReturnTrip, transferCar, priceGoing, priceReturn);
            }, angular.noop);
            this.localStorageService.set('bookingReferencesTransfers', [paymentOrderReferenceGoing, paymentOrderReferenceReturn]);
        } else {
            this.AncillariesService.updateGlobickTransfers(dateFormattedServiceGoingTrip, transferCar, priceGoing, hash, paymentOrderIdGoing, paymentOrderReferenceGoing).then(() => {
                this.AncillariesService.addGlobickTransfersToBasket(this.AncillariesConstants.QUADRIGAM.ANCILLARIES_BKI.toLowerCase(), dateFormattedGoingTrip, transferCar, priceGoing);
            }, angular.noop);
            this.localStorageService.set('bookingReferencesTransfers', [paymentOrderReferenceGoing]);
        }

        const bookingReferences:any =  this.localStorageService.get('bookingReferencesTransfers');
        const deleteInfo = [
            {
                type: this.AncillariesConstants.TYPE_ANCILLARIE.GLOBICK,
                items: [
                    {
                        product: 'TRANS',
                        bookingReferences: bookingReferences
                    }
                ]
            }
        ];
        this.CommonsSessionStorageService.set('removeGlobickTransfers', deleteInfo);

        this.$uibModalInstance.close();
        this.close();
        this.$rootScope.$broadcast('setConfirmed');
        this.completeTransferFlow();
    };

    getOrdersCallback () {}

    closeWidgetModalCallback = () => {
        const digitalDataInfo: object = {};
        const datalayerDataInfo: object = {};
        const flowApp: string = this.localStorageService.get('flowApp');

        digitalDataInfo[this.DatalayerConstants.DATALAYER_INFO.STEP_DIGITAL_DATA] = this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES;
        datalayerDataInfo[this.DatalayerConstants.DATALAYER_INFO.STEP] = this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES;
        this.DatalayerUtilsService.addDigitalDataInfo(digitalDataInfo);
        this.DatalayerUtilsService.addDataLayerInfo(datalayerDataInfo);

        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(this.DatalayerConstants.QUADRIGAMS[flowApp], null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(this.DatalayerConstants.QUADRIGAMS[flowApp], null, this.localStorageService.get('userLogged'));
        this.$uibModalInstance.close();
        this.close();
    };

    generateTravellers = () => {
        const bookingInfo:any = this.localStorageService.get('bookingInfo');
        const listTravellers = [];
        let travellerTemp = {};


        Object.keys(bookingInfo.passengers).forEach(key => {
            travellerTemp = {};

            travellerTemp = {
                name: bookingInfo.passengers[key].name,
                surname:  bookingInfo.passengers[key].surname,
                email:  '',
                dob:  '',
                address: '',
                country: '',
                countryPhoneCode: '',
                phone: '',
                countryMobileCode: '',
                mobile: '',
                language: '',
                nationality: '',
                passport: '',
                expenditureDate: '',
                expirationDate: '',
                zipCode: '',
                pickupLocation: ''
            };
            listTravellers.push(travellerTemp);
        });
        return listTravellers;
    };

    generateMountLocation (): string {
        const flowName = this.$rootScope.flowName;
        let flowNameReturned;
        if(flowName === 'BKI' || flowName === 'CKI' || flowName === 'MMB') {
            flowNameReturned = flowName;
        }else {
            flowNameReturned = '';
        }
        return flowNameReturned;
    }

    generateLanguageAndMarket (): string {
        const confirmationDatalayerInfo:any = (this.flowApp === 'BKI' || this.flowApp === 'BBKI') ? this.localStorageService.get('fareData') : this.localStorageService.get('confirmationDigitalInfo');
        let languageAndMarket;

        if (this.flowApp === 'BKI' || this.flowApp === 'BBKI') {
            if(confirmationDatalayerInfo.contextMetadata.language === 'es' ) {
                languageAndMarket = confirmationDatalayerInfo.contextMetadata.language + '-' + 'ES';
            }else if(confirmationDatalayerInfo.contextMetadata.language === 'en' ) {
                languageAndMarket = confirmationDatalayerInfo.contextMetadata.language + '-' + 'US';
            }else if(confirmationDatalayerInfo.contextMetadata.language === 'zh' ) {
                languageAndMarket = confirmationDatalayerInfo.contextMetadata.language + '-' + 'CN';
            }
        } else {
            if(confirmationDatalayerInfo.Language === 'es' ) {
                languageAndMarket = confirmationDatalayerInfo.Language + '-' + 'ES';
            }else if(confirmationDatalayerInfo.Language === 'en' ) {
                languageAndMarket = confirmationDatalayerInfo.Language + '-' + 'US';
            }else if(confirmationDatalayerInfo.Language === 'zh' ) {
                languageAndMarket = confirmationDatalayerInfo.Language + '-' + 'CN';
            }
        }
        return languageAndMarket;
    }

    checkIsPro (): string {
        let isPro;
        const widgetProMonetate = this.localStorageService.get('widgetProMonetate');
        const envCopy: any = {};
        (<any>Object).assign(envCopy, (<any>window).env);
        if(envCopy.production || widgetProMonetate) {
            isPro = 'prod';
        }else {
            isPro = 'test';
        }
        return isPro;
    }

    generateTransferReactWidgetModel = () => {
        let widgetModel: any = {};
        const flightAviosInfo:any = this.localStorageService.get('flightAviosInfo');
        const commercialData:any = this.localStorageService.get('commercialData');
        const bookingID:any = this.localStorageService.get('createOrderData');
        const bookingDate:any = (this.flowApp === 'MMB' || this.flowApp === 'MMBANC') ? this.localStorageService.get('breakdownInfo') : this.localStorageService.get('summaryInfo');
        const date:any = new Date().toTimeString().split(' ')[0];
        const hash:any = (this.flowApp === 'BKI' || this.flowApp === 'BBKI') ?  bookingID.order.bookingReferences[0].reference + '-' + bookingDate.context.bookingDate.split(' ')[0].replaceAll('-', '') :  bookingDate.context.locator + '-' + bookingDate.context.bookingDate.split(' ')[0].replaceAll('-', '');
        const arrivalDateForGlobick = bookingDate.context.segments[0];
        const locationForGlobick = bookingDate.context.segments[0].arrivalAirport;
        const currencyModel:any = (this.flowApp === 'MMB' || this.flowApp === 'MMBANC') ? commercialData?.currency.code : flightAviosInfo.currency.code;
        const originDestination:any = this.localStorageService.get('segmentsInfo');

        const generate = () => {
            return this.CommonsUtilService.sha256(hash).then((hashEID) => {
                widgetModel = {
                    env: this.checkIsPro(),
                    token: 'Bearer' + ' ' + this.tokenWidget,
                    clientBookingId: hashEID,
                    pickupLocation: locationForGlobick,
                    outboundTripDateTime: arrivalDateForGlobick.arrivalDate.replaceAll(' ', 'T'),
                    airline: bookingDate.context.segments[0].marketingFlight ? bookingDate.context.segments[0].marketingFlight.cabin.carrier : bookingDate.context.segments[0].operatingFlight.cabin.carrier,
                    flightNumber: bookingDate.context.segments[0].marketingFlight ? bookingDate.context.segments[0].marketingFlight.flightNumber : bookingDate.context.segments[0].operatingFlight.flightNumber,
                    returnTripDateTime: null,
                    returnAirline: null,
                    returnFlightNumber: null,
                    language: this.generateLanguageAndMarket(),
                    currency: currencyModel,
                    currencyExchange: null,
                    gaTrackingCode: 'test',
                    travellers: this.generateTravellers(),
                    mountLocation: this.generateMountLocation(),
                    getOrdersCallback: this.getOrdersCallback,
                    getTransferSearchCallback: null,
                    postOrderCallback: this.postOrderCallback,
                    closeWidgetModalCallback: this.closeWidgetModalCallback,
                    outboundFlightLocation: originDestination[0].origin.description + ' (' + originDestination[0].origin.code +')',
                    returnFlightLocation: originDestination[0].destination.description + ' (' + originDestination[0].destination.code + ')'
                };
                if(bookingDate.context.slices.length === 2) {
                    widgetModel.returnAirline = bookingDate.context.segments[1].marketingFlight ? bookingDate.context.segments[1].marketingFlight.cabin.carrier : bookingDate.context.segments[1].operatingFlight.cabin.carrier;
                    widgetModel.returnFlightNumber = bookingDate.context.segments[1].marketingFlight ? bookingDate.context.segments[1].marketingFlight.flightNumber : bookingDate.context.segments[1].operatingFlight.flightNumber;
                    widgetModel.returnTripDateTime = bookingDate.context.segments[1].departureDate.replaceAll(' ', 'T');
                }
                this.localStorageService.set('clientBookingIdTransfer', hashEID);
                return widgetModel;
            });
        };

        return generate().then((widgetModel) => {
            return widgetModel;
        });
    };


    initTransferWidget = () => {
        const digitalDataInfo = {}, datalayerDataInfo = {};

        digitalDataInfo[this.DatalayerConstants.DATALAYER_INFO.STEP_DIGITAL_DATA] = this.DatalayerConstants.DATALAYER_ANCILLARIES_STEPS.MOTRAS;
        datalayerDataInfo[this.DatalayerConstants.DATALAYER_INFO.STEP] = this.DatalayerConstants.DATALAYER_ANCILLARIES_STEPS.MOTRAS;

        this.DatalayerUtilsService.addDigitalDataInfo(digitalDataInfo);
        this.DatalayerUtilsService.addDataLayerInfo(datalayerDataInfo);

        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(this.DatalayerConstants.QUADRIGAMS.GLOBICK_TRANSFERS, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(this.DatalayerConstants.QUADRIGAMS.GLOBICK_TRANSFERS, null, this.localStorageService.get('userLogged'));


        this.ibGlobickTransfersService.getTokenWidget().then((response) => {
            this.tokenWidget = response.data.access_token;
            this.generateTransferReactWidgetModel().then((reactWidgetModel) => {
                this.$window.RecoglobickTransfersWidget.mount(reactWidgetModel);
                this.updateQuadrigam();
            });
        });
    };

    updateQuadrigam (): void {
        /* INIT DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(this.AncillariesConstants.QUADRIGAM.MODAL_SELECT_TRANSFER, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
        /* FINISH DELETE GA4 MIGRATION*/

        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(this.AncillariesConstants.QUADRIGAM.MODAL_SELECT_TRANSFER, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.updateDatalayerViewEvent();
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('sendUpdateToMonetate');
    }

    completeTransferFlow = (): void => {
        this.$window.RecoglobickTransfersWidget.unmount();

        const widgetVersion = '2.3.8';
        const baseUrl = this.getEnvUrlToGetWidgetCode();
        const urlTransfers = baseUrl + 'iberia-web-content/build-recoglobick-transfers/' + widgetVersion;

        const scriptTransferVendor = urlTransfers + '/static/js/2.vendor.chunk.js';
        const scriptTransferMain = urlTransfers + '/static/js/main.chunk.js';
        const scriptTransferRunTime = urlTransfers + '/static/js/runtime-main.js';
        const cssTransfersMain = urlTransfers + '/static/css/main.chunk.css';

        if (angular.element('script[src="' + scriptTransferVendor + '"]') !== null) {
            angular.element('script[src="' + scriptTransferVendor + '"]').remove();
            angular.element('script[src="' + scriptTransferMain + '"]').remove();
            angular.element('script[src="' + scriptTransferRunTime + '"]').remove();
            angular.element('link[href="' + cssTransfersMain + '"]').remove();
        }
    };

    /**
    * Close modal and send event for discard changes on insurance
    */
    close = (): void => {
        this.$uibModalInstance.close();
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
    };
}


try {
    ibGlobickTransfersModalCtrl.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(ibGlobickTransfersModalCtrl.name, ibGlobickTransfersModalCtrl);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    ibGlobickTransfersModalCtrl.$inject = controllerInfo.inject;
    mod.controller(ibGlobickTransfersModalCtrl.name, ibGlobickTransfersModalCtrl);
}